<template>
  <section class="app-main">
    <div v-if="openAdvertisingSpace && !['dashboard', 'page401', 'page404'].includes($route.name) && !$route?.meta?.iframeSrc" class="station-ad-box">
      <div id="mainAd" class="station-ad">
        <!-- <union-ad id="u6999072" :key="key"></union-ad> -->
      </div>
    </div>

    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition>
    <slot></slot>
  </section>
</template>

<script>
import { uuid } from "vue2-element-admin-plugin"
export default {
  name: "AppMain",
  watch: {
    $route: {
      handler: function(val) {
        if (this.openAdvertisingSpace && !["dashboard", "page401", "page404"].includes(val.name) && !val?.meta?.iframeSrc) {
          this.loadBaiduAdAsync()
        }
      },
      immediate: true
    }
  },
  computed: {
    openAdvertisingSpace() {
      return this.$store.getters.openAdvertisingSpace
    },
    cachedViews() {
      return this.$store.state.tagsView.cachedViews.map(item => item.name)
    },
    key() {
      return this.$route.fullPath
    }
  },
  methods: {
    /**
     * 加载百度广告
     * id值从百度联盟后台获取
     */
    loadBaiduAdAsync() {
      this.$nextTick(() => {
        // 获取绑定了 ref 的父元素
        const parentElement = document.getElementById("mainAd")
        // 清除元素内容
        parentElement.innerHTML = ""

        const className = uuid()

        // 创建一个新的元素
        const newElement = document.createElement("div")
        newElement.className = className // 添加类名
        newElement.innerHTML = `<div class="loading-spinner"><svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path"></circle></svg><!----></div>`

        // 将新元素添加到父元素中
        parentElement.appendChild(newElement);
        (window.slotbydup = window.slotbydup || []).push({
          id: "u6999072",
          container: className,
          async: true
        })
      })
    }
  }
}
</script>

<style></style>